<script>
export default {
  name: "MenuItem",
  functional: true,
  props: {
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  render(h, context) {
    const { icon, title } = context.props;
    const vnodes = [];

    if (icon) {
      vnodes.push(<svg-icon icon-class={icon}/>)
      // console.log("vnodes.push svg-icon miss");
    }

    if (title) {
      vnodes.push(<span slot="title">{title}</span>);
      // console.log("vnodes.push span miss");
    }
    return vnodes;
  }
};
</script>
